import { createSlice } from '@reduxjs/toolkit';

const initialState = {
    fetchTransactionFormConfigInProgress: false,
    fetchTransactionFormConfigError: null,

    initializingFormInProgress: false,
    initializingFormError: null,

    submitFormInProgress: false,
    submitFormError: null,

    discardTransactionInProgress: false,
    discardTransactionError: null,

    forms: {},
};

const formControlSlice = createSlice({
    name: 'formControl',
    initialState,
    reducers: {
        initializeNewForm(state, { payload: formId }) {
            state.forms[formId] = {
                form: {
                    values: {},
                    errors: {},
                    touched: {},
                },
            };
        },
        removeForm(state, { payload: formId }) {
            const { [formId]: toBeDeleted, ...rest } = state.forms;
            state.forms = rest;
        },

        registerNewFormField(state, { payload: { formId, fieldName, initialValue, disabled, required } }) {
            if (disabled) return;

            const form = state.forms[formId].form;

            form.values[fieldName] = initialValue;
            if (!required) return;
            form.errors[fieldName] = true;
            form.touched[fieldName] = false;
        },

        setFieldValue(state, { payload: { formId, fieldName, value } }) {
            const form = state.forms[formId].form;
            form.values[fieldName] = value;
        },

        setFieldTouched(state, { payload: { formId, fieldName } }) {
            const form = state.forms[formId].form;
            form.touched[fieldName] = true;
        },

        setFieldError(state, { payload: { formId, fieldName, error = true } }) {
            const form = state.forms[formId].form;
            form.errors[fieldName] = error;
        },
        removeFieldErrors(state, { payload: { formId } }) {
            const form = state.forms[formId].form;
            form.errors = {};
        },
        submitFormStart(state, { payload: { transactionId, locationId } }) {
            state.submitFormInProgress = true;
            state.submitFormError = null;
        },
        submitFormFailed(state, { payload: error }) {
            state.submitFormInProgress = false;
            if (error) state.submitFormError = error;
        },

        setSubmitFormInProgress(state, { payload: submitFormInProgress }) {
            state.submitFormInProgress = submitFormInProgress;
        },
        // removeForm(state, { payload: formId }) {
        //     const { [formId]: toBeDeleted, rest } = state.forms;
        //     state.forms = { ...rest };
        // },
        setFormValues(state, { payload: { formId, newFormValues } }) {
            const form = state.forms[formId].form;
            const { values, errors, touched } = form || {};
            Object.keys(values).forEach((fieldName) => {
                const hasIncomingValue = newFormValues && newFormValues.hasOwnProperty(fieldName);

                let valueToSet = hasIncomingValue ? newFormValues[fieldName] : values[fieldName];

                if (!hasIncomingValue && (valueToSet || valueToSet === undefined))
                    switch (typeof valueToSet) {
                        case 'boolean':
                            valueToSet = false;
                            break;
                        case 'string':
                            valueToSet = '';
                            break;

                        default:
                            valueToSet = null;
                    }

                values[fieldName] = valueToSet;
                errors.hasOwnProperty(fieldName) && (errors[fieldName] = !!!(hasIncomingValue && (valueToSet || valueToSet === false)));
                touched.hasOwnProperty(fieldName) && (touched[fieldName] = !!hasIncomingValue);
            });
        },
    },
});

export const formControlActions = formControlSlice.actions;
export const formControlReducer = formControlSlice.reducer;
